<ng-template #addAndEditPopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
    </div>
    <button class="close close-button" (click)="cancelAddAndEditFunction()" mat-button><i
        class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
      <label for="title" class="popupTitle"> {{ popupTitle }}</label>
    </div>
    <div class="form-continer">
      <div class="row">
        <div class="col-md-12">
          <div><label id="justification-validation" for="email">Justification For Parallel Workflow</label><span
              class="mandatory-symbol">*</span></div>
          <textarea id="groupDescription" type="text" class="input-filed-textarea" rows="4" cols="50"
            [(ngModel)]="qualityGroup.reasonForWorkflow"></textarea>
        </div>
      </div>
    </div>
  </div>
  <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
    <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="addAndEditFunction()"
      (keydown.enter)="addAndEditFunction()">
      <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
      <span class="reload_text text-white">Add New</span>
    </div>
    <button mat-stroked-button class="cancelButton" (click)="cancelAddAndEditFunction()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>